module.exports = "data:application/x-font-ttf;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJmb250cy9nbHlwaGljb25zLWhhbGZsaW5ncy1yZWd1bGFyLWUxOGJiZi50dGYiOw=="


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap/dist/fonts/glyphicons-halflings-regular.ttf
// module id = 793
// module chunks = 2